<!--*** Registration ***-->
<!--import select2Component from '../VueComponents/SElect2/Select2.vue.html';-->
<!--Vue.component('select2-component', select2Component);-->
<!--***Javascript array mode***-->
<!--<select2-component :options="dropDown.HeadAndNeckSubSiteDropDown" v-model="model.headAndNeckSubsiteId" :value="model.headAndNeckSubsiteId" :width="'450px'"></select2-component>-->
<!--***Server side ajax mode***-->
<!--<select2-component :url="/api/Allergences" v-model="model.headAndNeckSubsiteId" :value="model.headAndNeckSubsiteId" :width="'450px'"></select2-component>-->
<!-- if you want a predined list for ajax calls pass in :ajax-default-options="list of default options"-->
<!--***dom mode - you write out the options ie: server side in asp.net razor view***-->
<!--<select2-component fromdom="true" v-error-message="{ errorModel: 'errorModel.frequencyAndDoseId' }"  v-model="model.frequencyAndDoseId" class="form-control" :width="'100%'" placeholder="Frequency And Dose">
                              <option value=""></option>
                              <option value="1">Bla</option>
                          </select2-component>-->
<!-- to disable searching just add  data-minimum-results-for-search="Infinity" to your component. ie: <select2 data-minimum-results...="Infinity"-->

<template>
    <select class="el" :style="widthCssOutput" :multiple="ismultiselect" :disabled="disabled">
        <option v-if="url && ajaxPreSelectedValue" :value="value" selected="selected">{{ajaxPreSelectedValue}}</option>
        <slot></slot>
    </select>
</template>

<script>

    //multi select. with min characters. Type 3 characters then back space to 1...says "enter more characters". The top of that div is split with the drop down. The resize - repaints it and corrects the issue
    $(document).on('keyup', '.select2-search__field', function () {
        $(window).trigger('resize');
    });

    import './portal.select2.scss';
    import $ from 'jquery';
    import select2 from 'select2';
    import * as t from 'select2/dist/js/i18n/es';
    import 'select2-bootstrap4-theme/dist/select2-bootstrap4.css';
    import jlinq from '@SharedServices/linq.javascript.service.js';
    import { CurrentLanguage } from '@SharedServices/localization.service';

    export default {
        name: 'select2',
        props: ['options', 'url', 'value', 'width', 'addblankentry', 'placeholder', 'allowclear', 'ismultiselect', 'ajaxmincharactersearch', 'ajaxdefaultoptions', 'disabled', 'disableresultsort'],
        data: function () {
            return {
                widthCssOutput: 'width:' + this.width
            }
        },
        watch: {
            options: function (options) {
                // update options
                $(this.$el).empty().select2(this.buildConfig());//.val(this.value).trigger('change');
            },
            value: function (value) {

                // alert(value);
                //multi select's end up with too many calls as you change the value then pass it back in. We are going to only update if the value has change which speeds it up
                if (JSON.stringify(value) != JSON.stringify($(this.$el).val())) {
                    $(this.$el).val(value).trigger('change');
                }
            }
        },
        computed: {

            optionsToBind: function () {

                if (!this.addblankentry) {
                    return this.options;
                }

                //we never want to modify the existing array incase this gets shared between stuff..so we always concat it (which creates a new array)
                return [{ id: '' }].concat(this.options);
            },

            ajaxPreSelectedValue: function () {

                //assumes this is a grouping.
                if (!this.value || this.ajaxdefaultoptions == null) {
                    return null;
                }

                let tryToFind = this.ajaxdefaultoptions.SelectMany(x => x.children).FirstOrDefault(x => {
                    x.id == this.value
                });

                return tryToFind == null ?
                    null :
                    tryToFind.text;
            }

        },
        mounted: function () {

            $(this.$el)
                // init select2
                .select2(this.buildConfig())
                .val(this.value)
                .trigger('change')
                // emit event on change.
                .on('select2:select', e => {
                    //e.params.data.id

                    //need to handle multiple drop down id's so we just grab the element and set it
                    this.$emit('input', $(this.$el).val());
                })
                .on('select2:open', e => {
                    //see issue above at the top of the screen (//multi select. with min characters.)
                    setTimeout(x => $(window).trigger('resize'), 10);
                    this.$emit('onOpen');
                }).on('change', e => {
                    //chrome auto fill for forms only triggers here and not select2: Select....so we capture and emit this as well
                    this.$emit('input', $(this.$el).val());
                });
         
            let ariaLabel = $(this.$el).attr('aria-label');

            //add the aria label if present for multiple
            if (this.ismultiselect && ariaLabel) {
                $(this.$el).siblings('.select2-container').find('.select2-search__field').attr('aria-label', ariaLabel);
            }
        },
        methods: {

            buildConfig: function () {
           
                let config = {
                    theme: "bootstrap4",
                    placeholder: this.placeholder,
                    //data: this.optionsToBind,
                    allowClear: this.allowclear,
                    multiple: this.ismultiselect,

                    //if we really need to overide it more...we can use the follwoing below.
                    language: CurrentLanguage() == "es-419" ? "es": "en"

                    //language: {
                    //    // You can find all of the options in the language files provided in the
                    //    // build. They all must be functions that return the string that should be
                    //    // displayed.
                    //    inputTooShort: function () {
                    //        return ResolveStaticContent('SelectMinTextEnteredError')
                    //    }
                    //}
                };

                //if the width is set use it. Otherwise make it it respond to the screen resizing.
                if (this.width) {
                    config.width = this.width;
                }
                else {
                    config.width = '100%';

                    //this solution would expand the drop down > 100% when you open it up with all options.
                    //config.dropdownAutoWidth = true;
                    //config.width = 'auto';
                }

                if (this.url) {
                    if (this.ajaxdefaultoptions) {
                        config.dataAdapter = this.getAjaxDataAdapterForAjax();
                    }

                    config.ajax = {
                        url: this.url,
                        dataType: 'json',
                        delay: 255,
                        headers: {
                            "IgnoreAborts": true, //select 2 aborts calls when you keep typing and a pending ajax request is after the current one. We catch this in layout.entry.js so we don't display the error banner
                        },
                        data: function (params) {
                            return {
                                searchText: params.term //encodeURIComponent(params.term)
                            };
                        },
                        processResults: function (data, page) {
                            // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to
                            // alter the remote JSON data
                            return {
                                results: data
                            };
                        },
                        cache: false
                    };

                    config.minimumInputLength = this.ajaxmincharactersearch == null ? 3 : this.ajaxmincharactersearch;
                    config.defaultValues = this.ajaxdefaultoptions;
                }
                else if (this.fromdom == null && this.optionsToBind) {
                    config.data = this.optionsToBind;
                }

                //essentially show the items first that match earlier in the string indexOf(searchText)
                if (!this.ismultiselect && (this.disableresultsort == null || !this.disableresultsort)) {

                    //disable this for multi select.
                    config.sorter = this.sortByIndexOfSearchText;
                }

                return config;
            },

            sortByIndexOfSearchText: function (data) {

                var searchValue = $(this.$el).data("select2").dropdown.$search.val();

                var search = function (a, b) {
                    a = a.text.toLowerCase();
                    b = b.text.toLowerCase();

                    if (searchValue && searchValue != '') {

                        var searchValueLower = searchValue.toLowerCase();

                        a = a.indexOf(searchValueLower);
                        b = b.indexOf(searchValueLower);
                    }

                    if (a > b) {
                        return 1;
                    } else if (a < b) {
                        return -1;
                    }
                    return 0;
                };

                var isGroupDropDown = function (data) {
                    for (var t = 0; t < data.length; t++) {
                        if (data[t].children && data[t].children.length > 0) {
                            return true;
                        }
                    }

                    return false;
                };

                //regular drop down vs a grouped (like message [recent vs all])
                if (!isGroupDropDown(data)) {

                    //regular drop down
                    return data.sort(search);
                }

                //grouped drop down (like messages). Order the children
                for (var i = 0; i < data.length; i++) {
                    data[i].children = data[i].children.sort(search);
                }

                return data;
            },

            getSelectedTextValue: function () {
                return $(this.$el).select2('data');
            },

            getAjaxDataAdapterForAjax: function () {

                $.fn.select2.amd.define('select2/data/customAdapter', [
                    'select2/data/ajax',
                    'select2/utils'
                ],
                    function (AjaxAdapter, Utils) {

                        function CustomDataAdapter($element, options) {
                            CustomDataAdapter.__super__.constructor.call(this, $element, options);
                        }

                        Utils.Extend(CustomDataAdapter, AjaxAdapter);

                        CustomDataAdapter.prototype.query = function (params, callback) {

                            //display this if we aren't up to the min length that they need to add (this is the default option list)
                            //var ALL_OPTION = defaultOptions;

                            if (params.term && params.term.length >= this.options.options.minimumInputLength) {
                                this.ajaxOptions.transport(this.options.options.ajax.url + '?searchText=' + params.term).done(x => {
                                    callback({ results: x });
                                });

                            } else {
                                callback({ results: this.options.options.defaultValues });
                            }
                        }

                        return CustomDataAdapter;
                    }
                );

                return $.fn.select2.amd.require('select2/data/customAdapter');
            }

        },
        destroyed: function () {
            $(this.$el).select2('destroy');
        }
    };
</script>